import React, { FC, ReactElement, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import { setLanguage } from "state/base/actions";
import { useSelector, useDispatch } from "react-redux";
import { getUserInfo } from "@/state/base/reducer";
import { AppState } from "@/state";
import i18n from "i18next";
import { useTranslation } from "react-i18next";

const Main = styled.div`
  width: 100%;
  height: 100%;
`;

const View = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: auto;
`;
const LanguageView = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 6;
  .overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 2;
  }
`;
const LanguageContent = styled.div`
  position: fixed;
  top: 0.54rem;
  right: 0.16rem;
  width: 0.92rem;
  z-index: 10;
  background: rgba(255, 254, 254, 0.9);
  border-radius: 0.08rem;
  padding: 0.06rem 0;
  border: 0.01rem solid #ffffff;
`;
const LanguageLibs = styled.div`
  line-height: 0.36rem;
  text-align: center;
  font-size: 0.13rem;
  font-weight: 400;
  color: #666666;
  position: relative;

  &.active {
    color: #0093db;
  }
`;
const TopBar = styled.h4`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: bold;
  color: #7c53f2;
  z-index: 100;
  padding: 0.12rem 0.16rem;
  .right-side{
    display:inline-flex;
    justify-content: end;
    align-items: center;
    font-size:0.12rem;
    .recover{
      margin-right:0.16rem;
      font-weight:400;
    }
    .connect-area {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0.06rem 0.12rem;
      border-radius: 0.16rem;
      border: 0.01rem solid rgba(0, 147, 219, 0.4);
      text-align: center;
      backdrop-filter: blur(0.05rem);
      font-size: 0.12rem;
      font-weight: 400;
      color: #0093db;

      img {
        width: 0.2rem;
        margin-left: 0.08rem;
      }
  }
  }
`;

const Icon = styled.i`
  font-size: 0.2rem;

  &.back {
    color: #000000;
    float: left;
    font-weight: 400;
    position: relative;
    top: 50%;
    margin-right: 0.1rem;
    transform: translateY(-50%);
    font-size: 0.22rem;
  }
`;

const LogoIng = styled.img.attrs((props) => ({
  src: props.src,
  alt: props.alt,
}))`
  height: 0.32rem;
`;

const Layout: FC = ({ children }): ReactElement => {
  const { t } = useTranslation();
  const { topBar, account } = useSelector((state: AppState) => state.baseInfo);
  let dispatch = useDispatch();
  // let location = useLocation()
  let history = useHistory();
  const [showLange, setShowLange] = useState<boolean>(false);
  const [activeLange, setActiveLange] = useState<string>(
    window.localStorage.getItem("lange") ?? "en_US"
  );
  const langeList = [
    { title: "English", key: "en_US" },
    { title: "繁体中文", key: "zh_HK" },
    { title: "한국어", key: "ko_KR" },
    { title: "Pусский", key: "ru" },
  ];
  useEffect(() => {
    i18n.changeLanguage(activeLange);
    dispatch(setLanguage(activeLange));
    window.localStorage.setItem("lange", activeLange);
  }, [activeLange, dispatch]);
  useEffect(() => {
    if (account.name) return;
    dispatch(getUserInfo());
  }, [dispatch, account.name]);

  const connectWallt = () => {
    if (account.name) return;
    dispatch(getUserInfo());
  };
  const setLange = (item): void => {
    setActiveLange(item.key);
    setShowLange(false);
  };

  return (
    <Main>
      <TopBar>
        {!!topBar.goback && (
          <Icon
            onClick={() => history.push({ pathname: topBar.goback })}
            className="iconfont back"
          >
            &#xe656;
          </Icon>
        )}
        {/* {topBar.title} */}
        <LogoIng
          src={require("img/logo.svg").default}
          onClick={() => history.push({ pathname: "/home" })}
        />
        <div className="right-side">
          {/* {
            location.pathname !== '/recover' &&
            <span className="recover" onClick={() => history.push({ pathname: '/recover' })}>{t("layout.Recover account")}</span>
          } */}
          <div className="connect-area">
            <p onClick={connectWallt}>
              {account.name ? account.name : t("layout.connect")}
            </p>
            <img
              src={require("img/icon_language.svg").default}
              alt=""
              onClick={() => setShowLange(true)}
            />
          </div>
        </div>
      </TopBar>
      {showLange && (
        <LanguageView>
          <div className="overlay" onClick={() => setShowLange(false)}></div>
          <LanguageContent>
            {langeList.map((item) => (
              <LanguageLibs
                key={item.key}
                className={item.key === activeLange && "active"}
                onClick={() => setLange(item)}
              >
                {item.title}
              </LanguageLibs>
            ))}
          </LanguageContent>
        </LanguageView>
      )}
      <View>{children}</View>
    </Main>
  );
};

export default Layout;
